import { useState, useEffect } from "react";

declare global {
  interface Window {
    grecaptcha: ReCaptchaInstance;
    captchaOnLoad: () => void;
  }
}

interface ReCaptchaInstance {
  ready: (cb: () => any) => void;
  execute: (options: ReCaptchaExecuteOptions) => Promise<string>;
  render: (id: string, options: ReCaptchaRenderOptions) => any;
}

interface ReCaptchaExecuteOptions {
  action: string;
}

interface ReCaptchaRenderOptions {
  sitekey: string;
  size: "normal";
  callback: (res: string) => void;
}

interface IGreCaptcha {
  verifyCallback: (res: string) => void;
}

export default function GreCaptcha({ verifyCallback }: IGreCaptcha) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const scriptTag = document.createElement("script");
    scriptTag.async = true;
    scriptTag.defer = true;
    scriptTag.src = "https://www.google.com/recaptcha/api.js";
    scriptTag.addEventListener("load", () => setLoaded(true));
    document.body.appendChild(scriptTag);
  }, []);

  const callback = (res: string) => verifyCallback(res);

  function renderReCaptcha() {
    window.grecaptcha.render("grecaptchaContiner", {
      sitekey: import.meta.env.VITE_GRECAPTCHA_TOKEN,
      size: "normal",
      callback,
    });
  }

  useEffect(() => {
    if (!loaded) return;
    window.grecaptcha.ready(() => renderReCaptcha());
  }, [loaded]);

  return (
    <div
      className="flex w-full items-center justify-center"
      id="grecaptchaContiner"
    />
  );
}
